<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Profili</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn text title="Nuovo profilo" @click="openNew">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="3">
									<v-text-field
										v-model="searchfield"
										label="Cerca per nome o email"
										outlined
										append-icon="mdi-magnify"
										dense
										clearable
										hide-details
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
										@click:clear="clearSearch()"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.billingType"
										:items="billingTypes"
										item-text="text"
										item-value="value"
										label="Billing"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.financeStatus"
										:items="financeStatuses"
										item-text="text"
										item-value="value"
										label="Finance"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.active"
										:items="activeOptions"
										item-text="text"
										item-value="value"
										label="Attivo"
										outlined
										dense
										clearable
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getProfiles"
							:options.sync="settings.options"
							:server-items-length="total"
							:loading="loading"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							must-sort
							class="elevation-0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="profile-list-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="confirmDelete(item)">
																<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center mb-1">
														<v-chip x-small dark :color="financeStatusColor(item.finance && item.finance.status)">
															{{ financeStatusLabel(item.finance && item.finance.status) }}
														</v-chip>
													</div>
													<div class="text-caption grey--text text--darken-1 mb-1">{{ item._id }}</div>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch
														v-model="item.active"
														:loading="togglingId === item._id"
														:disabled="togglingId === item._id"
														color="primary"
														hide-details
														dense
														class="mt-0 pt-0"
														@change="toggleActive(item)"
													></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="confirmDelete(item)">
														<v-list-item-title class="size9 error--text">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
											<div>{{ createdAtLabel(item) }}</div>
											<div class="text-caption grey--text text--darken-1">{{ item._id }}</div>
										</td>
										<td>
											<div class="font-weight-medium">{{ item.name }}</div>
											<div class="text-caption grey--text text--darken-1">{{ item.website || '-' }}</div>
										</td>
										<td>
											<div>{{ item.email || '-' }}</div>
											<div class="text-caption grey--text text--darken-1">{{ phoneLabel(item) }}</div>
										</td>
										<td>{{ billingLabel(item.billingType) }}</td>
										<td>
											<v-chip x-small dark :color="financeStatusColor(item.finance && item.finance.status)">
												{{ financeStatusLabel(item.finance && item.finance.status) }}
											</v-chip>
										</td>
										<td>{{ formatDate(item.finance && item.finance.activatedAt) }}</td>
										<td>{{ formatDate(item.finance && item.finance.expiredAt) }}</td>
										<td>{{ item.finance && item.finance.months ? item.finance.months : '-' }}</td>
										<td>{{ formatValue(item) }}</td>
										<td :title="partialPeriod(item)">
											<template v-if="hasPartial(item)">
												<div>{{ formatEuro(item.finance.partial.total) }}</div>
												<div class="text-caption grey--text text--darken-1">
													{{ item.finance.value }}% = {{ formatEuro(partialGross(item)) }}
													<span v-if="item.finance.partial.minApplied" class="orange--text text--darken-2">
														&rarr; minimo {{ formatEuro(item.finance.partial.min) }}
													</span>
												</div>
											</template>
											<template v-else>-</template>
										</td>
										<td>{{ item.affiliate && item.affiliate.name ? item.affiliate.name : '-' }}</td>
										<td>
											<v-switch
												v-model="item.active"
												:loading="togglingId === item._id"
												:disabled="togglingId === item._id"
												color="primary"
												hide-details
												class="mt-0 pt-0"
												@change="toggleActive(item)"
											></v-switch>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog persistent v-model="dialogdelete" width="640px">
			<v-card>
				<v-card-title class="red lighten-5 py-4 title">
					<v-icon color="error" class="mr-2">mdi-alert-octagon</v-icon>
					Elimina definitivamente il profilo
				</v-card-title>
				<v-card-text class="pt-4">
					<p class="mb-2">
						Stai per eliminare <strong>{{ deleteTarget.name }}</strong> e <strong>tutti</strong> i dati collegati:
					</p>
					<p class="mb-2">
						utenti, ordini, prodotti, varianti, categorie, clienti, spedizioni e costi di spedizione, documenti, coupon, listini e ogni altro dato del profilo, oltre ai
						file caricati su S3.
					</p>
					<p class="red--text font-weight-bold mb-4">L'operazione è irreversibile e non è previsto alcun ripristino.</p>
					<v-text-field
						v-model="deleteConfirmName"
						label="Digita il nome del profilo per confermare"
						:placeholder="deleteTarget.name"
						outlined
						dense
						hide-details
						autocomplete="off"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text :disabled="deleting" @click="dialogdelete = false">Annulla</v-btn>
					<v-btn color="error" :loading="deleting" :disabled="!canDelete" @click.prevent="removeProfile">Elimina definitivamente</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'ProfilesManage',
	components: { KeyValueCard },
	// stato della lista nell'URL: tornando dalla scheda profilo si ritrovano pagina e filtri
	mixins: [
		listRouteState({
			filters: { billingType: 'string', financeStatus: 'string', active: 'boolean' },
			perPageOptions: LIST_SIZE,
			fetch: 'initialize',
		}),
	],
	data() {
		return {
			// ricerca/filtri/paginazione: applicati lato server
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					billingType: null,
					financeStatus: null,
					active: null,
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 25,
				},
			}),
			// il campo di ricerca diventa `settings.search` solo al click sulla lente o con invio
			searchfield: '',
			total: 0,
			loading: false,
			listSize: LIST_SIZE,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Creazione', value: 'created_at' },
				{ text: 'Identità', value: 'name' },
				{ text: 'Contatti', value: 'email' },
				{ text: 'Billing', value: 'billingType' },
				{ text: 'Finance', value: 'finance.status' },
				{ text: 'Attivazione', value: 'finance.activatedAt' },
				{ text: 'Scadenza', value: 'finance.expiredAt' },
				{ text: 'Mesi', value: 'finance.months' },
				{ text: 'Valore', value: 'finance.value' },
				{ text: 'Parziale', value: 'finance.partial.total', sortable: false },
				{ text: 'Affiliato', value: 'affiliate.name' },
				{ text: 'Attivo', value: 'active', sortable: false },
			],
			billingTypes: [
				{ text: 'Fisso', value: 'fixed' },
				{ text: 'Commissione', value: 'commission' },
			],
			financeStatuses: [
				{ text: 'Attivo', value: 'active' },
				{ text: 'In scadenza', value: 'due' },
				{ text: 'Scaduto', value: 'expired' },
				{ text: 'Annullato', value: 'cancelled' },
			],
			activeOptions: [
				{ text: 'Attivo', value: true },
				{ text: 'Non attivo', value: false },
			],
			dialogdelete: false,
			deleteTarget: { _id: '', name: '' },
			deleteConfirmName: '',
			deleting: false,
			togglingId: '',
			snackbar: {
				snackbar: false,
				color: '',
				mode: 'multi-line',
				timeout: 5000,
				text: '',
			},
		};
	},
	created() {
		this.listLoad();
	},
	computed: {
		...mapGetters({
			getProfiles: 'profiles/getProfiles',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// il bottone si sblocca solo con il nome esatto del profilo
		canDelete() {
			return this.deleteConfirmName.trim() === (this.deleteTarget.name || '').trim() && !!this.deleteTarget._id;
		},
	},
	methods: {
		...mapActions({
			fetchProfiles: 'profiles/asyncFetchProfiles',
			patchActive: 'profiles/patchActive',
			destroyProfile: 'profiles/deleteProfile',
		}),
		confirmDelete(item) {
			this.deleteTarget = { _id: item._id, name: item.name || '' };
			this.deleteConfirmName = '';
			this.dialogdelete = true;
		},
		async removeProfile() {
			if (!this.canDelete) {
				return;
			}
			this.deleting = true;
			try {
				const res = await this.destroyProfile({ _id: this.deleteTarget._id, confirmName: this.deleteConfirmName.trim() });
				this.dialogdelete = false;
				this.snackbar.color = 'success';
				this.snackbar.text = `Profilo "${this.deleteTarget.name}" eliminato (${res.data.total} documenti, ${res.data.s3} file)`;
				this.snackbar.snackbar = true;
				// il totale e la pagina corrente arrivano dal server: serve un refetch
				await this.initialize();
			} catch (err) {
				this.snackbar.color = 'error';
				this.snackbar.text =
					(err.response && err.response.data && err.response.data.error && err.response.data.error[0] && err.response.data.error[0].msg) ||
					'Errore durante eliminazione del profilo';
				this.snackbar.snackbar = true;
				if (err.response && err.response.status === 401) {
					this.$router.push('/login');
				}
			} finally {
				this.deleting = false;
			}
		},
		async toggleActive(item) {
			this.togglingId = item._id;
			try {
				await this.patchActive({ _id: item._id, active: item.active });
				this.snackbar.color = 'success';
				this.snackbar.text = item.active ? 'Profilo attivato' : 'Profilo disattivato';
				this.snackbar.snackbar = true;
			} catch (err) {
				// revert dello switch in caso di errore
				item.active = !item.active;
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore aggiornamento stato';
				this.snackbar.snackbar = true;
				if (err.response && err.response.status === 401) {
					this.$router.push('/login');
				}
			} finally {
				this.togglingId = '';
			}
		},
		// coppie chiave/valore della card su telefono (stessi dati delle colonne desktop)
		campiCard(item) {
			const finance = item.finance || {};
			let parziale = '-';
			if (this.hasPartial(item)) {
				const partial = finance.partial;
				parziale = `${this.formatEuro(partial.total)} (${finance.value}% = ${this.formatEuro(this.partialGross(item))}`;
				parziale += partial.minApplied ? ` → minimo ${this.formatEuro(partial.min)})` : ')';
			}
			return [
				{ label: 'Creazione', value: this.createdAtLabel(item) },
				{ label: 'Sito', value: item.website },
				{ label: 'Email', value: item.email },
				{ label: 'Telefono', value: this.phoneLabel(item) },
				{ label: 'Billing', value: this.billingLabel(item.billingType) },
				{ label: 'Attivazione', value: this.formatDate(finance.activatedAt) },
				{ label: 'Scadenza', value: this.formatDate(finance.expiredAt), strong: true },
				{ label: 'Mesi', value: finance.months || '' },
				{ label: 'Valore', value: this.formatValue(item), strong: true },
				{ label: 'Parziale', value: parziale },
				{ label: 'Affiliato', value: item.affiliate && item.affiliate.name },
			];
		},
		// il telefono del profilo vive nei dati di spedizione/ritiro in sede
		phoneLabel(item) {
			if (!item || !item.ShippingAddress) return '-';
			return item.ShippingAddress.Phone || item.ShippingAddress.MobilePhone || '-';
		},
		billingLabel(value) {
			const found = this.billingTypes.find(el => el.value === value);
			return found ? found.text : 'Fisso';
		},
		financeStatusLabel(value) {
			const labels = { active: 'Attivo', due: 'In scadenza', expired: 'Scaduto', cancelled: 'Annullato' };
			return labels[value] || 'Attivo';
		},
		financeStatusColor(value) {
			const colors = { active: 'success', due: 'orange', expired: 'error', cancelled: 'red darken-4' };
			return colors[value] || 'success';
		},
		formatDate(value) {
			return value ? moment(value).format('DD/MM/YYYY') : '-';
		},
		// i profili creati prima dell'attivazione di `timestamps` non hanno `created_at`:
		// l'ObjectId incorpora comunque il momento di creazione nei primi 4 byte
		createdAtLabel(item) {
			if (!item) return '-';
			if (item.created_at) return this.formatDate(item.created_at);
			const seconds = parseInt(String(item._id || '').substring(0, 8), 16);
			return seconds ? this.formatDate(new Date(seconds * 1000)) : '-';
		},
		formatEuro(value) {
			return `€ ${(Number(value) || 0).toFixed(2)}`;
		},
		// il parziale lo calcola il server, solo per i profili a commissione con una scadenza impostata
		hasPartial(item) {
			const finance = (item && item.finance) || {};
			return finance.billingType === 'commission' && !!finance.partial;
		},
		partialPeriod(item) {
			if (!this.hasPartial(item)) return '';
			const partial = item.finance.partial;
			const base = `Ordini dal ${this.formatDate(partial.from)} al ${this.formatDate(partial.to)} (escluso) - ${partial.orders} ordini`;
			return partial.minApplied ? `${base} - importo effettivo ${this.formatEuro(partial.commission)} (minimo garantito)` : base;
		},
		// commissione maturata al netto del minimo: `gross` manca se il backend non e' ancora aggiornato
		partialGross(item) {
			const partial = ((item && item.finance) || {}).partial || {};
			return partial.gross != null ? partial.gross : partial.commission;
		},
		// il valore e' un importo in euro con billing fisso, una percentuale con billing a commissione
		formatValue(item) {
			const finance = (item && item.finance) || {};
			const value = Number(finance.value) || 0;
			const min = Number(finance.min) || 0;
			const billingType = finance.billingType || (item && item.billingType) || 'fixed';
			if (billingType === 'commission') {
				// un contratto puo' avere solo il minimo (percentuale a zero): non e' un contratto vuoto
				if (!value && !min) return '-';
				return min > 0 ? `${value} % (min ${this.formatEuro(min)})` : `${value} %`;
			}
			return value ? `€ ${value.toFixed(2)}` : '-';
		},
		// la ricerca parte solo dalla lente o con invio, non a ogni tasto: pagina 1 e ricarica le fa listRouteState
		getSearch() {
			this.settings.search = (this.searchfield || '').trim();
		},
		clearSearch() {
			this.searchfield = '';
			this.settings.search = '';
		},
		// caricamento della pagina corrente: lo chiama listRouteState quando cambiano pagina, ordinamento o filtri
		async initialize() {
			this.loading = true;
			try {
				const pagination = await this.fetchProfiles(this.settings);
				this.total = pagination ? pagination.total : 0;
			} catch (err) {
				console.log(err);
			} finally {
				this.loading = false;
			}
		},
		openNew() {
			this.$router.push('/manage/profiles/new');
		},
		editItem(item) {
			if (!item) return;
			this.$router.push(`/manage/profiles/${item._id}`);
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.profile-list-cards,
.profile-list-cards tr {
	display: block;
	width: 100%;
}
.profile-list-cards tr,
.profile-list-cards tr:hover {
	background: transparent !important;
}
.profile-list-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.profile-list-cards tr:first-child td {
	padding-top: 12px !important;
}
.profile-list-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.profile-list-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
